import PropTypes from "prop-types";

const fieldTypes = {
    error: PropTypes.bool.isRequired,
    data: PropTypes.string.isRequired,
    handleInputChange: PropTypes.func.isRequired
};

export default fieldTypes;
